/**
 * Utility functions that may be useful in multiple situations.
 */

// Load an external script at runtime, ensuring it loads only once.
// Source: https://css-tricks.com/snippets/javascript/async-script-loader-with-callback/
class Loader {
  scriptsLoaded = {};

  require(scripts, callback, loadOnce) {
    this.loadCount = 0;
    this.totalRequired = scripts.length;
    this.callback = callback;

    for (let i = 0; i < scripts.length; i++) {
      this.writeScript(scripts[i], loadOnce);
    }
  }

  loaded(evt) {
    this.loadCount += 1;

    if (evt) {
      this.scriptsLoaded[evt.target.src] = true;
    }

    if (
      this.loadCount === this.totalRequired &&
      typeof this.callback === 'function'
    ) {
      this.callback.call();
    }
  }

  writeScript(src, loadOnce) {
    if (src in this.scriptsLoaded && loadOnce !== false) {
      this.loaded();
      return;
    }

    const self = this;
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = src;
    s.addEventListener('load', (e) => self.loaded(e), false);
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  }
}

// Ensure requestAnimationFrame only runs on a certain interval.
function rafThrottle(interval, callback) {
  let lastRefresh;

  window.requestAnimationFrame((timestamp) => {
    if (lastRefresh === undefined) {
      lastRefresh = timestamp;
    }

    if (lastRefresh + interval < timestamp) {
      callback();
      lastRefresh = timestamp;
    } else {
      window.requestAnimationFrame(callback);
    }
  });
}

export { Loader, rafThrottle };
